/**
 * Eshop photogallery support
 *
 */
import $ from 'jquery';
import {decorateInnerElements, disposeInnerComponents} from 'fg-frontend/src/webComponents/decorate';
import Hammer from '../third/hammer.min';

var PLUGIN_NAME = 'edeeshopPhotogallery';

var DEFAULTS = {
  magnifyEnabled: true,
  model3DEnabled: true,
  arrowsEnabled: true,
  bulletsEnabled: false,
  popupGalleryEnabled: true,
  onlyThumbnailEnabled: false,
  allowKeyboardSwitch: true,
  allowMousewheelSwitch: true,
  allowTouchSwipeSwitch: true,
  webpEnabled: false,
  retinaEnabled: false,

  //selectors
  thumblistSelector: '.thumblist',
  thumbitemSelector: '> li > a',
  model3ditemSelector: '> li.model-3d',
  galleryContainerSelector: '.gallery-detail-container',
  activeDetail: 0,

  //events
  onAfterPhotoChange: 'EDEESHOP_PHOTOGALLERY_PHOTO_CHANGE'
};

var EdeeShopPhotogallery = function (selector, options) {
  this.$t = $(selector);
  this.options = $.extend(true, {}, DEFAULTS, options);
  this._defaults = DEFAULTS;

  // blank jquery objects used further
  this.zoomButton = null;

  this.activeDetail = this.options.activeDetail;
  this.swipeDetail = this.options.activeDetail;
  this.difference = 0;
  this.mouseOverState = false;

  this.itemWidth = 0;
  this.itemsCount = 0;
  this.initialItemsCount = 0;
  this.prevItemsCount = 0;

  window.active3DModel = null;

  this.initialise_();
};

EdeeShopPhotogallery.prototype.initialise_ = function () {
  this.thumbs = $(this.options.thumblistSelector + ' ' + this.options.thumbitemSelector, this.$t);
  this.$detailgalleryContainer = $(this.options.galleryContainerSelector, this.$t);

  if (this.$detailgalleryContainer.length == 0) {
    this.$detailgalleryContainer = this.$t;
  }

  var thumbCount = this.thumbs.length;
  var hasModel3d = $(this.options.thumblistSelector + ' ' + this.options.model3ditemSelector, this.$t).length;
  if (thumbCount > 0 || hasModel3d) {
    this.renderDetails_();
    if ((thumbCount === 1) && (!this.options.onlyThumbnailEnabled)) {
      if (!hasModel3d) {
        $(this.options.thumblistSelector, this.$t).hide();
      } else {
        this.thumbs.parents('li').hide();
      }
    } else {
      if (!this.options.popupGalleryEnabled) {
        this.bindThumbnailsSelect_();
      }

      if (thumbCount > 1) {
        if (this.options.arrowsEnabled) {
          this.renderControlArrows_();
        }
        if (this.options.bulletsEnabled) {
          this.renderControlBullets_();
        }
      }
    }
  }

  this.initialItemsCount = this.thumbs.length;

  this.bindHandlers_();

  return true;
};

/**
 * bind component handlers
 * @private
 */
EdeeShopPhotogallery.prototype.bindHandlers_ = function () {
  const self_ = this;

  this.$t
    .on('mouseenter', function () {
      self_.mouseOverState = true;
    })
    .on('mouseleave', function () {
      self_.mouseOverState = false;
    });

  if (this.options.allowKeyboardSwitch) {
    this.bindKeyboardSwitchHandler_();
  }

  if (this.options.allowMousewheelSwitch) {
    this.bindMousewheelSwitchHandler_();
  }

  // swipe
  const hammertime = new Hammer(this.$t.get(0));
  hammertime.on("swipeleft", function (ev) {
    if (document.querySelector('.eshop-gallery--popup')) return;
    self_.thumbnailChangeByDir_('next');
  });
  hammertime.on("swiperight", function (ev) {
    if (document.querySelector('.eshop-gallery--popup')) return;
    self_.thumbnailChangeByDir_('prev');
  });

  window.addEventListener("resize", function () {
    self_.swipePrepare_();
  });

  window.addEventListener("resize", function () {
    self_.setActiveDetail_();
  });
};


EdeeShopPhotogallery.prototype.swipePrepare_ = function () {
  const self_ = this;
  const items = document.querySelectorAll('.eshop-gallery--page .eshop-gallery__item');
  const galleryDetailWidth = document.querySelector('.eshop-gallery--page .gallery-detail-container').offsetWidth;
  this.itemsCount = items.length;
  let containerWidth = galleryDetailWidth * this.itemsCount;
  document.querySelector('.eshop-gallery--page .gallery-detail').style.width = containerWidth + 'px';
  this.itemWidth = containerWidth / this.itemsCount;
  items.forEach(function (item) {
    item.style.width = self_.itemWidth + 'px';
  });
};

/**
 * bind keyboard switch handler
 * @private
 */
EdeeShopPhotogallery.prototype.bindKeyboardSwitchHandler_ = function () {
  const self_ = this;
  const eventId = 'keyup.' + this.$t.attr('id');

  if (this.thumbs.length > 1) {
    $(document).off(eventId).on(eventId, function (event) {

      if ((self_.mouseOverState) && (!(window.activeZoom instanceof $)) && (window.active3DModel === null)) {
        if (event.which == 37) {
          self_.thumbnailChangeByDir_('prev');
        }
        if (event.which == 39) {
          self_.thumbnailChangeByDir_('next');
        }
      }
    });
  }
};

/**
 * bind mousewheel switch handler
 * @private
 */
EdeeShopPhotogallery.prototype.bindMousewheelSwitchHandler_ = function () {
  const self_ = this;
  const eventId = 'mousewheel.' + this.$t.attr('id') + ' DOMMouseScroll.' + this.$t.attr('id');

  if (this.thumbs.length > 1) {
    self_.$detailgalleryContainer.off(eventId).on(eventId, function (event) {

      if ((self_.mouseOverState) && (!(window.activeZoom instanceof $)) && (window.active3DModel === null)) {
        if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
          if (self_.activeDetail != 0) {
            self_.thumbnailChangeByDir_('prev');
            event.preventDefault();
          }
        } else {
          if (self_.activeDetail != (self_.thumbs.length - 1)) {
            self_.thumbnailChangeByDir_('next');
            event.preventDefault();
          }
        }
      }
    });
  }
};


/**
 * render details from thumbnails
 * render initial zoom button
 */
EdeeShopPhotogallery.prototype.renderDetails_ = function () {
  this.$detailgallery = $('<ul class="eshop-gallery__detail gallery-detail"></ul>');
  var detailZoom = '',
    detailId = '',
    detailItem = '',
    pictureWidth = 0,
    pictureHeight = 0,
    zoomWidth = 0,
    zoomHeight = 0,
    alt = '',
    imgData,
    imgSizes,
    href,
    webpHref,
    retinaHref,
    retinaWebpHref,
    picture = '';

  /**
   * render single details
   */
  for (var i = 0; i < this.thumbs.length; i++) {
    // add index to thumbnail for future use
    $(this.thumbs[i])
      .data('index', i);
    detailZoom = $(this.thumbs[i])
      .data('zoom') || '';
    detailId = $(this.thumbs[i])
      .attr('id');
    detailItem = $(this.thumbs[i])
      .data('item') || '0';
    zoomWidth = this.$t.data('zoomWidth');
    zoomHeight = this.$t.data('zoomHeight');
    pictureWidth = this.$t.data('pictureWidth');
    pictureHeight = this.$t.data('pictureHeight');
    alt = $(this.thumbs[i])
      .find('img')
      .attr('alt');
    href = $(this.thumbs[i])
      .attr('href');

    imgData = $(this.thumbs[i])
      .data('img');
    imgSizes = this.$t.data('sizes');

    picture = this.getPicture_(imgData, imgSizes, detailId, detailZoom, alt, pictureWidth, pictureHeight);

    // render detail
    $('<li class="eshop-gallery__item' + (i === this.activeDetail ? ' active' : '') + '' + (i === 0 ? ' eshop-gallery__item--first' : '') + '">' +
      '<div id="EshopImageZoom" data-is="EshopImageZoom">' +
      (this.options.popupGalleryEnabled ? '<a href="javascript:" class="eshop-gallery__link img-container" data-is="EshopGalleryPopup" id="' + detailId + '_detail" data-item="' + detailItem + '">' : '') +
      '<div class="eshop-gallery__image-stage" data-fragment="EshopImageZoom.imageState"><div class="eshop-gallery__image-wrap" data-fragment="EshopImageZoom.imageWrap">' +
      picture +
      '</div></div>' +
      (this.options.popupGalleryEnabled ? '</a>' : '') +
      ('<div class="eshop-gallery__zoom-control"><a href="javascript:" class="eshop-gallery__zoom-control-item eshop-gallery__zoom-control-item--in" data-fragment="EshopImageZoom.plus"><span class="widget-controls__ico ico"><svg class="svg-icon svg-icon--in"><use xlink:href="/build/img/svg/svg-sprite.svg#plus"></use></svg></span></a><span class="eshop-gallery__control-percent" data-fragment="EshopImageZoom.percentage">0%</span><a href="javascript:" class="eshop-gallery__zoom-control-item eshop-gallery__zoom-control-item--out eshop-gallery__zoom-control-item--disabled" data-fragment="EshopImageZoom.minus"><span class="widget-controls__ico ico"><svg class="svg-icon svg-icon--out"><use xlink:href="/build/img/svg/svg-sprite.svg#minus"></use></svg></span></a></div></div>') +
      '</li>')
      .appendTo(this.$detailgallery);
  }

  /**
   * set first thumbnail marked as active
   */
  $(this.thumbs[this.activeDetail]).parents('li').addClass('active');

  /**
   * render zoom button
   */
  this.renderZoomButton_($(this.thumbs[this.activeDetail]).data('zoom'));

  /**
   * prepend this whole package to DOM
   */
  this.$detailgallery.appendTo(this.$detailgalleryContainer);

  decorateInnerElements(this.$detailgallery.get(0));

  this.swipePrepare_();
};


/**
 * returns picture element structure
 */
EdeeShopPhotogallery.prototype.getPicture_ = function (data, sizesData, id, zoom, alt, width, height) {
  const self_ = this;

  let result = '<picture>';
  let href = null;

  let webp,
    x,
    i,
    sizes = '';

  i = 0;
  for (let key in sizesData) {
    if (i != 0) {
      sizes += ', ';
    }
    sizes += '(min-width: ' + key.replace('minWidth', '') + 'px) ' + sizesData[key];
    i++;
  }

  if (sizes != '') {
    sizes = ' sizes="' + sizes + '"';
  }

  webp = data.webp;

  if (self_.options.webpEnabled && typeof (webp) != 'undefined') {
    result += '<source srcset="';
    i = 0;
    for (let key in webp) {
      if (i != 0) {
        result += ', ';
      }
      result += webp[key] + ' ' + key + 'w';
      i++;
    }
    result += '"' + sizes + ' type="image/webp">';
  }

  x = data.x;
  if (typeof (x) != 'undefined') {
    result += '<source srcset="';
    i = 0;
    for (let key in x) {
      if (i != 0) {
        result += ', ';
      }
      href = x[key];
      result += x[key] + ' ' + key + 'w';
      i++;
    }
    result += '"' + sizes + '>';
  }

  result += '<img id="' + id + '_img" class="eshop-gallery__img" src="' + href + '" data-magnify-src="' + zoom + '" alt="' + alt + '" width="' + width + '" height="' + height + '" data-fragment="EshopImageZoom.img" fetchpriority="high">';
  result += '</picture>';
  return result;
};


/**
 * removes zoombutton from DOM
 * @private
 */
EdeeShopPhotogallery.prototype.clearZoomButton_ = function () {
  if (this.zoomButton instanceof $) {
    $(this.zoomButton).remove();
  }
};

/**
 * renders zoom button
 * @private
 */
EdeeShopPhotogallery.prototype.renderZoomButton_ = function (zoomImagePath) {
  /**
   * feature is disabled
   */
  if (!this.options.magnifyEnabled) {
    return false;
  }

  /**
   * clear zoombutton first
   */
  this.clearZoomButton_();
};

/**
 *
 * @private
 */
EdeeShopPhotogallery.prototype.renderControlArrows_ = function () {
  this.$controlArrows = $('<p class="eshop-gallery__controls widget-controls gallery-controls"></p>');
  /* span unvnitř odkazu je kvůli nastylování pomocí bootstrap .glyphicon, eg:
      .prev span {
          .glyphicon;
          .glyphicon-ico-arrow;
      }
  */
  var arrowLeft = $('<a href="javascript:" class="eshop-gallery__controls-item eshop-gallery__controls-item--prev widget-controls__item widget-controls__item--prev prev" data-dir="prev"><span class="widget-controls__ico ico"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#arrow"></use></svg></span></a>').appendTo(this.$controlArrows);
  var arrowRight = $('<a href="javascript:" class="eshop-gallery__controls-item eshop-gallery__controls-item--next widget-controls__item widget-controls__item--next next" data-dir="next"><span class="widget-controls__ico ico"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#arrow"></use></svg></span></a>').appendTo(this.$controlArrows);
  this.$controlArrows.appendTo(this.$detailgalleryContainer);
  /*var galleryContainer = document.querySelector('.eshop-gallery');
  this.$controlArrows.appendTo(galleryContainer);*/

  if (!document.querySelector('.eshop-gallery--popup')) {
    var galleryContainer = document.querySelector('.eshop-gallery');
    this.$controlArrows.appendTo(galleryContainer);
  } else {
    this.$controlArrows.appendTo(this.$detailgalleryContainer);
  }
  this.bindControlArrows_();
};

EdeeShopPhotogallery.prototype.bindControlArrows_ = function () {
  var self_ = this;
  this.$controlArrows.on('click', '> a', function (event) {
    event.preventDefault();
    var dir = $(event.currentTarget).data('dir');

    self_.thumbnailChangeByDir_(dir);
  });
};

/**
 *
 * @private
 */
EdeeShopPhotogallery.prototype.renderControlBullets_ = function () {
  var bullet, activeBullet;
  this.$controlBullets = $('<p class="eshop-gallery__bullets widget-bullets"></p>');
  for (var i=0; i < this.thumbs.length; i++) {
    if (i == this.activeDetail) {
      activeBullet = ' widget-bullets__item--active';
    }
    else {
      activeBullet = '';
    }
    bullet = $('<a href="javascript:" class="eshop-gallery__bullets-item widget-bullets__item' + activeBullet + '" data-item="' + i + '"><span></span></a>').appendTo(this.$controlBullets);
  }
  this.$controlBullets.appendTo(this.$detailgalleryContainer);
  this.bindControlBullets_();
};

EdeeShopPhotogallery.prototype.bindControlBullets_ = function () {
  var self_ = this;
  this.$controlBullets.on('click', '> a', function (event) {
    event.preventDefault();
    var item = $(event.currentTarget).data('item');

    self_.difference = parseInt(item) - self_.activeDetail;
    self_.activeDetail = parseInt(item);
    self_.thumbnailChange_('from_bullets');
  });
  $('.eshop-gallery__bullets-item--more').click(function (e) {
    e.preventDefault();
    $('.eshop-gallery__bullets-container').addClass('eshop-gallery__bullets-container--all');
    $('.eshop-gallery__bullets-container').parent().addClass('eshop-gallery__detail-container--bullets-expanded');
  });
};

EdeeShopPhotogallery.prototype.thumbnailChangeByDir_ = function (dir) {
  var self_ = this;

  // clone picture for swipe
  if (!document.querySelector('.eshop-gallery--popup')) {
    let negativePrevItemsCount = self_.prevItemsCount * (-1);
    if (dir == 'prev' && (self_.swipeDetail == negativePrevItemsCount)) {
      self_.prevItemsCount = self_.prevItemsCount + 1;
      self_.itemsCount = self_.itemsCount + 1;
      negativePrevItemsCount = self_.prevItemsCount * (-1);
      let cloneElement = $('.eshop-gallery--page .eshop-gallery__item').eq(self_.initialItemsCount - 1).clone();
      cloneElement.css('position', 'absolute').css('left', +self_.itemWidth * negativePrevItemsCount + 'px').prependTo('.eshop-gallery--page .gallery-detail');
      cloneElement.click(function (e) {
        document.querySelector('.eshop-gallery--page .eshop-gallery__item.active .eshop-gallery__link').click();
      });
    } else if (dir == 'next' && self_.itemsCount == self_.swipeDetail + 1 + self_.prevItemsCount) {
      let cloneElement = $('.eshop-gallery--page .eshop-gallery__item').eq(self_.itemsCount - self_.initialItemsCount).clone();
      cloneElement.appendTo('.eshop-gallery--page .gallery-detail');
      cloneElement.click(function (e) {
        document.querySelector('.eshop-gallery--page .eshop-gallery__item.active .eshop-gallery__link').click();
      });
      self_.swipePrepare_();
    }
  }

  // add or substract one
  self_.activeDetail = dir == 'prev' ? self_.activeDetail - 1 : self_.activeDetail + 1;
  self_.swipeDetail = dir == 'prev' ? self_.swipeDetail - 1 : self_.swipeDetail + 1;

  // if reached prev threshold, push it to the last thumbnail
  self_.activeDetail = self_.activeDetail < 0 ? (self_.thumbs.length) - 1 : self_.activeDetail;

  // if reached next trehshold, push it to the first thumbnail
  self_.activeDetail = self_.activeDetail > (self_.thumbs.length) - 1 ? 0 : self_.activeDetail;

  self_.thumbnailChange_();
};


/**
 * handle clicking on thumbnail
 * @private
 */
EdeeShopPhotogallery.prototype.bindThumbnailsSelect_ = function () {
  var self_ = this;
  $(this.options.thumblistSelector, this.$t).on('click', this.options.thumbitemSelector, function (event) {
    event.preventDefault();

    /**
     * set active detail
     * @type {Number}
     */
    self_.activeDetail = parseInt($(event.currentTarget).data('index'));
    self_.thumbnailChange_();
  });
};

EdeeShopPhotogallery.prototype.thumbnailChange_ = function (type) {
  /**
   * mark thumb as active
   */
  this.setActiveThumbnail_();

  /**
   * mark detail as active
   */
  this.setActiveDetail_(type);

  /**
   * trigger on after change
   */
  $(document).trigger(this.options.onAfterPhotoChange, [{
    instance: this
  }]);
};

EdeeShopPhotogallery.prototype.setActiveThumbnail_ = function () {
  const self_ = this;
  $(this.thumbs).parents('li').removeClass('active');
  $(this.thumbs[this.activeDetail]).parents('li').addClass('active');

  this.swipeDetail = this.swipeDetail + this.difference;
  this.difference = 0;

  if (this.options.bulletsEnabled) {
    this.$controlBullets.find('a').removeClass('widget-bullets__item--active');
    this.$controlBullets.find('a:eq(' + this.activeDetail + ')').addClass('widget-bullets__item--active');
    if (this.activeDetail > 5) {
      $('.eshop-gallery__bullets-container').addClass('eshop-gallery__bullets-container--all');
      $('.eshop-gallery__bullets-container').parent().addClass('eshop-gallery__detail-container--bullets-expanded');
    }
  }
};

EdeeShopPhotogallery.prototype.setActiveDetail_ = function (type) {
  const self_ = this;
  let pointer = this.activeDetail;

  if (!document.querySelector('.eshop-gallery--popup')) {
    let marginLeft = 0;
    if (type == "from_bullets") {
      this.$detailgallery.addClass("no-transition");
      this.swipeDetail = this.activeDetail;
      marginLeft = (this.itemWidth * this.activeDetail) * -1;
      this.$detailgallery.fadeOut(100, function () {
        self_.$detailgallery.css('margin-left', marginLeft + 'px');
        self_.$detailgallery.fadeIn(100);
      });
    } else {
      this.$detailgallery.removeClass("no-transition");
      marginLeft = (this.itemWidth * this.swipeDetail) * -1;
      this.$detailgallery.css('margin-left', marginLeft + 'px');
    }
    pointer = this.activeDetail + this.prevItemsCount;
  }

  $(' > li', this.$detailgallery).removeClass('active');
  $(' > li:eq(' + pointer + ')', this.$detailgallery).addClass('active');
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *    if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *    if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  var args = arguments;

  return this.each(function () {
    var $this = $(this);

    // get plugin instance
    var plugin = $this.data('plugin_' + PLUGIN_NAME);

    // if there's not, create one
    if (!plugin) {
      plugin = new EdeeShopPhotogallery(this, value);
      $this.data('plugin_' + PLUGIN_NAME, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/edeeshop/jquery.edeeshop-photogallery.js